import Captcha from "@Captcha";
import { useHandleResize } from "@hook";
import { useCrypto } from "@hook";
import { InputMask } from "@react-input/mask";
import ButtonUi from "@UI/ButtonUi";
import InputTextUi from "@UI/InputTextUi";
import SelectFilialUI from "@UI/SelectFilialUI";
import VerificationPhone from "@UI/VerificationPhone";
import { formatPhoneNumber, getSqlServerGuidHash, sendMetric, getWhatId, clearParamWithoutRerender, getAbTestMetrika, validateEmail, validatePhone, saveToLocalStorage, isCaptchaEnabled, normalizePhoneDigits, getOfferLegalInfo } from "@utils";

import { inject, observer } from "mobx-react";
import React, { useState, useEffect, useRef } from "react";

import FilialBlock from "./FilialBlock";
import Icon from "./img/icon.svg";
import "./style.scss";
import { getErrorStatus } from "../../../../helpers/apiError";
import RecommendationModal from "../../../Modal/RecommendationModal";

const maskType = "+7 (___) ___-__-__";
const { VITE_WHAT_ID } = import.meta.env;

const AB_3274 = inject("mainStore")(
    observer(({ mainStore, offerItem, setIsAccordionOpen, percentNumber }) => {
        const abTest = mainStore.getMainStore("abTest");
        const abTestMetika = mainStore.getMainStore("abTestMetika");
        const regionId = mainStore.getMainStore("promoIdRegion");
        const cityId = mainStore.getMainStore("promoIdCity");
        const metroId = mainStore.getMainStore("promoIdMetro");
        const indexPositionMetrick = mainStore.getMainStore("indexPositionMetrik");
        const cityArr = mainStore.getMainStore("citiesData");
        const metroArr = mainStore.getMainStore("metroData");
        const wdCd = mainStore.getMainStore("codeTypeMetrika");
        const wdm = mainStore.getMainStore("codeWdm");
        const wd_mc = mainStore.getMainStore("codeWdMc");
        const getPromoUrl = mainStore.getMainStore("getPromoUrl");
        const formQuestionsChain = mainStore.getMainStore("formQuestionsChain");
        const userLocation = mainStore.getMainStore("userLocation");
        const { encryptData, decryptData } = useCrypto();

        const [inputFieldsState, setInputFieldsState] = useState({ name: false, email: false, phone: false });
        const [codeValue, setCodeValue] = useState({ 0: "", 1: "", 2: "", 3: "" });
        const [errorEmail, setErrorEmail] = useState(false);
        const [errorName, setErrorName] = useState(false);
        const [errorPhone, setErrorPhone] = useState(false);
        const [errorCity, setErrorCity] = useState(false);
        const [errorMetro, setErrorMetro] = useState(false);
        const [errorFilial, setErrorFilial] = useState(false);
        const [error, setError] = useState(false);
        const [loaderBtn, setLoaderBtn] = useState(false);
        const [suggestEmailValue, setSuggestEmailValue] = useState("");
        const [sendPhone, setSendPhone] = useState(false);
        const [smsType, setSmsType] = useState("");
        const [correlationId, setCorrelationId] = useState(false);
        const [filialObj, setFilialObj] = useState(false);
        const [cityIdFilter, setCityIdFilter] = useState([]);
        const [focusMask, setFocusMask] = useState(false);

        const inputEmailRef = useRef();
        const inputNameRef = useRef();
        const inputPhoneRef = useRef();
        const shouldStopRef = useRef(false);
        const wrapperRef = useRef(null);

        const isMobile = useHandleResize();
        const isVerified = offerItem?.inputFields?.find((item) => item.isVerified === true);
        const offerButtonLabel = !sendPhone ? "Получить подарок" : "Получить предложение";
        const { showLegalInfo, vendorId, vendorName, ord } = getOfferLegalInfo(offerItem, filialObj);
        const what_id = getWhatId() ? getWhatId() : VITE_WHAT_ID;
        const isAbTestMetrika = getAbTestMetrika(abTest, offerItem?._id);

        useEffect(() => {
            if (Object.values(codeValue).join("").length === 4) {
                handleClick();
            }
        }, [codeValue]);

        useEffect(() => {
            if (localStorage.getItem("userToken") && localStorage.getItem("userToken") !== null) {
                let obj = JSON.parse(decryptData(localStorage.getItem("userToken")));
                if (inputPhoneRef && inputPhoneRef.current) {
                    inputPhoneRef.current.value = formatPhoneNumber(obj.phone);
                }
                setInputFieldsState(obj);
            }

            if (!wrapperRef.current) return;
        }, []);

        useEffect(() => {
            setSmsType(offerItem?.offerDetail?.smsProviderType);
        }, [offerItem?.offerDetail?.smsProviderType]);

        const handleClick = async (isCodeReplace = false) => {
            setLoaderBtn(true);

            let obj = { email: inputFieldsState && inputFieldsState.email ? inputFieldsState.email.toLowerCase() : "", phone: normalizePhoneDigits(inputFieldsState.phone), name: inputFieldsState.name };
            let check = false;

            let paramsKey8 = null;
            if (!offerItem.offerDetail.showInputsInModal) {
                paramsKey8 = inputFieldsState.email ? inputFieldsState.email?.toLowerCase() : inputFieldsState.email;
            }
            if (offerItem?.inputFields?.some((it) => it.type === "phone")) {
                paramsKey8 = inputFieldsState.phone;
            }
            if (offerItem?.inputFields?.some((it) => it.type === "phone") && offerItem?.inputFields?.some((it) => it.type === "email")) {
                paramsKey8 = (inputFieldsState.email ? inputFieldsState.email?.toLowerCase() : inputFieldsState.email) + "," + inputFieldsState.phone;
            }

            if (offerItem.offerDetail.showInputsInModal) {
                check = true;
            } else {
                if (offerItem?.inputFields?.filter((f) => f.active).length) {
                    const validateOrder = [...offerItem.inputFields].sort((a, b) => a.sort - b.sort);
                    const tmp = [];

                    setErrorEmail(false);
                    setErrorPhone(false);
                    setErrorName(false);
                    setErrorCity(false);
                    setErrorFilial(false);
                    setLoaderBtn(false);

                    for (const item of validateOrder) {
                        const errorFind = validateFields(item.key, item.require);

                        if (errorFind) {
                            validateFields(item.key, item.require);
                            return;
                        } else {
                            tmp.push(item[0]);
                        }
                        const reqFields = validateOrder.filter((f) => f[2] && f[3]).map((m) => m[0]);
                        if (reqFields.every((e) => tmp.includes(e))) check = true;
                    }
                } else {
                    const errorFind = validateFields("email", true);
                    setLoaderBtn(false);
                    if (!errorFind) {
                        check = true;
                    }
                }
            }

            if (check) {
                if (obj) {
                    if (localStorage.getItem("userToken") && localStorage.getItem("userToken") !== null) {
                        let objOld = JSON.parse(decryptData(localStorage.getItem("userToken")));
                        const string = encryptData(JSON.stringify({ ...objOld, ...obj }));
                        localStorage.setItem("userToken", string);
                    } else {
                        const string = encryptData(JSON.stringify(obj));
                        localStorage.setItem("userToken", string);
                    }
                }
                if (isVerified) {
                    if (Object.values(codeValue).join("").length === 4) {
                        if (isCodeReplace) {
                            const resp = await mainStore.getByUrl("app_rispromo_user/verify_phone", { offerId: offerItem?._id, phone: inputFieldsState["phone"], ...(smsType?.length ? { typeProvider: smsType } : {}) }, false, "", false);
                            if (resp && resp.success) {
                                setLoaderBtn(false);
                                sendMetric("click_phone_code_again", {
                                    params1: [`${abTestMetika ? abTestMetika : "ris_promo"}`],
                                    params2: offerItem?._id,
                                    params3: getSqlServerGuidHash(offerItem.code, offerItem.vendor?._id),
                                    params4: offerItem?.code,
                                    params6: isAbTestMetrika ? `${isAbTestMetrika}` : null,
                                    params7: null,
                                    params8: what_id,
                                });
                            }
                            return;
                        } else {
                            setLoaderBtn(true);

                            if (correlationId) {
                                const resp = await mainStore.getByUrl("/app_rispromo_user/check_verify_phone", { correlation_id: correlationId, code: Object.values(codeValue).join("") }, false, "", false);

                                if (resp && resp.success) {
                                    onSubmitGetPromo(obj, paramsKey8);
                                    setLoaderBtn(false);
                                } else {
                                    setLoaderBtn(false);
                                    sendMetric(`add_invalid_phone_code`, {
                                        params1: [`${abTestMetika ? abTestMetika : "ris_promo"}`],
                                        params2: offerItem?._id,
                                        params3: getSqlServerGuidHash(offerItem.code, offerItem.vendor?._id),
                                        params4: offerItem?.code,
                                        params6: isAbTestMetrika ? `${isAbTestMetrika}` : null,
                                        params7: paramsKey8,
                                        params8: what_id,
                                    });
                                }
                            } else {
                                const resp = await mainStore.getByUrl(
                                    "app_rispromo_user/verify_phone",
                                    { offerId: offerItem?._id, phone: inputFieldsState["phone"], code: Object.values(codeValue).join(""), ...(smsType?.length ? { typeProvider: smsType } : {}) },
                                    false,
                                    "",
                                    false,
                                );

                                if (resp && resp.success) {
                                    onSubmitGetPromo(obj, paramsKey8);
                                    setLoaderBtn(false);
                                } else {
                                    setLoaderBtn(false);
                                    sendMetric(`add_invalid_phone_code`, {
                                        params1: [`${abTestMetika ? abTestMetika : "ris_promo"}`],
                                        params2: offerItem?._id,
                                        params3: getSqlServerGuidHash(offerItem.code, offerItem.vendor?._id),
                                        params4: offerItem?.code,
                                        params6: isAbTestMetrika ? `${isAbTestMetrika}` : null,
                                        params7: paramsKey8,
                                        params8: what_id,
                                    });
                                }
                            }
                        }
                    } else {
                        if (!Object.values(codeValue).join("").length && sendPhone && !isCodeReplace) {
                            mainStore.setMainStore("toast", { severity: "error", life: 4000, summary: "", detail: "Пожалуйста, укажите код" });
                            setError(true);
                            setLoaderBtn(false);
                        } else {
                            if (Object.values(codeValue).join("").length !== 0 && Object.values(codeValue).join("").length !== 4) {
                                setError(true);
                                return;
                            }

                            setLoaderBtn(true);
                            if (isCodeReplace) setSmsType("smsProsto");

                            const body = isCodeReplace ? { phone: inputFieldsState["phone"], typeProvider: "smsProsto" } : { phone: inputFieldsState["phone"], ...(smsType?.length ? { typeProvider: smsType } : {}) };

                            const resp = await mainStore.getByUrl("app_rispromo_user/verify_phone", { ...body, offerId: offerItem?._id }, false, "", false);

                            if (resp && resp.data && resp.data.isAlreadyReceivedVendor) {
                                if (isMobile) {
                                    setSendPhone("received");
                                } else {
                                    mainStore.setMainStore("modal", { type: "recommendation", offerItem });
                                }
                                return;
                            }

                            if (resp && getErrorStatus(resp) === 502) {
                                setSmsType("pushMts");
                                setSendPhone(true);
                            }

                            if (resp && resp.success) {
                                setLoaderBtn(false);

                                if (smsType === "pushMts") {
                                    setSendPhone(true);

                                    const checkVerifyPhone = async (id) => {
                                        try {
                                            const resp = await mainStore.getByUrl("/app_rispromo_user/check_verify_phone", { correlation_id: id }, false, "", false);
                                            setLoaderBtn(true);

                                            if (!resp?.data) return;

                                            const { data } = resp;

                                            // Если нужно переключиться на SMS
                                            if (data.typeValidation === "sms") {
                                                shouldStopRef.current = true;
                                                setLoaderBtn(false);
                                                // setSmsType("smsMts");
                                                // реактивное обновление
                                                return;
                                            }

                                            // Если верификация прошла
                                            if (data.isValid) {
                                                onSubmitGetPromo(obj, paramsKey8);
                                                shouldStopRef.current = true; // останавливаем проверки
                                                return;
                                            }

                                            // Если ошибка
                                            if (getErrorStatus(resp) === 400) {
                                                shouldStopRef.current = true;
                                                setLoaderBtn(false);
                                            }
                                        } catch (e) {
                                            console.error(e);
                                            shouldStopRef.current = true;
                                            setLoaderBtn(false);
                                        }
                                    };

                                    const checkVerifyPhoneWithDelay = async (id) => {
                                        await checkVerifyPhone(id);

                                        if (!shouldStopRef.current) {
                                            setTimeout(() => checkVerifyPhoneWithDelay(id), 3000);
                                        }
                                    };

                                    setCorrelationId(resp.data.correlation_id);

                                    checkVerifyPhoneWithDelay(resp.data.correlation_id);
                                }
                                if (resp && resp.data && resp.data.correct === true) {
                                    onSubmitGetPromo(obj, paramsKey8);
                                } else {
                                    setSendPhone(true);

                                    if (isCodeReplace) {
                                        sendMetric("click_phone_code_again", {
                                            params1: [`${abTestMetika ? abTestMetika : "ris_promo"}`],
                                            params2: offerItem?._id,
                                            params3: getSqlServerGuidHash(offerItem.code, offerItem.vendor?._id),
                                            params4: offerItem?.code,
                                            params6: isAbTestMetrika ? `${isAbTestMetrika}` : null,
                                            params7: null,
                                            params8: what_id,
                                        });
                                    } else {
                                        sendMetric(`click_phone_code`, {
                                            params1: [`${abTestMetika ? abTestMetika : "ris_promo"}`],
                                            params2: offerItem?._id,
                                            params3: getSqlServerGuidHash(offerItem.code, offerItem.vendor?._id),
                                            params4: offerItem?.code,
                                            params6: isAbTestMetrika ? `${isAbTestMetrika}` : null,
                                            params7: paramsKey8,
                                            params8: what_id,
                                        });
                                    }
                                }
                            }
                        }
                    }
                } else {
                    onSubmitGetPromo(obj, paramsKey8);
                }
            }
        };

        const validateFields = (key, require) => {
            switch (key) {
                case "name":
                    if (require) {
                        if (inputNameRef?.current) {
                            setErrorName(false);
                            if (inputNameRef.current.value) {
                                const re = /^[^- ][а-яё -]*[^-]$/i;
                                if (!re.test(inputNameRef.current.value.toString().toLowerCase())) {
                                    setErrorName(true);
                                    mainStore.setMainStore("toast", { severity: "error", life: 4000, summary: "", detail: "Пожалуйста, укажите имя используя только буквы кириллицы" });
                                    return true;
                                } else {
                                    return false;
                                }
                            } else {
                                setErrorName(true);
                                mainStore.setMainStore("toast", { severity: "error", life: 4000, summary: "", detail: "Пожалуйста, укажите имя используя только буквы кириллицы" });
                                return true;
                            }
                        }
                    }
                    break;
                case "phone":
                    if (require) {
                        if (inputPhoneRef?.current) {
                            setErrorPhone(false);

                            if (inputPhoneRef.current.value) {
                                if (validatePhone(inputPhoneRef.current.value)) {
                                    setErrorPhone(false);
                                    return false;
                                } else {
                                    setErrorPhone(true);
                                    mainStore.setMainStore("toast", { severity: "error", life: 4000, summary: "", detail: "Пожалуйста, введите корректный номер телефона" });
                                    return true;
                                }
                            } else {
                                setErrorPhone(true);
                                mainStore.setMainStore("toast", { severity: "error", life: 4000, summary: "", detail: "Пожалуйста, введите ваш номер телефона" });
                                return true;
                            }
                        }
                    } else {
                        setErrorPhone(false);
                        return true;
                    }
                    break;
                case "email":
                    if (require) {
                        if (inputEmailRef?.current) {
                            setErrorEmail(false);
                            if (inputEmailRef.current.value) {
                                if (validateEmail(inputEmailRef.current.value)) {
                                    setErrorEmail(false);
                                    return false;
                                } else {
                                    setErrorEmail("Пожалуйста, введите корректный email");
                                    mainStore.setMainStore("toast", { severity: "error", life: 4000, summary: "", detail: "Пожалуйста, введите корректный email" });
                                    return true;
                                }
                            } else {
                                setErrorEmail("Пожалуйста, введите ваш email");
                                mainStore.setMainStore("toast", { severity: "error", life: 4000, summary: "", detail: "Пожалуйста, введите ваш email" });
                                return true;
                            }
                        }
                    }
                    break;
                case "city":
                    if (require) {
                        if (offerItem?.addresses?.addresses.length == 1 || (filialObj && filialObj.city)) {
                            setErrorCity(false);
                            return false;
                        } else {
                            setErrorCity("Пожалуйста, выберите город");
                            mainStore.setMainStore("toast", { severity: "error", life: 4000, summary: "", detail: "Пожалуйста, выберите город" });
                            return true;
                        }
                    }
                    break;

                case "metro":
                    if (require) {
                        if (arrMetroFilial.length) {
                            if (offerItem?.addresses?.addresses.length == 1 || (filialObj && filialObj.metro)) {
                                setErrorMetro(false);
                                return false;
                            } else {
                                setErrorMetro("Пожалуйста, выберите метро");
                                mainStore.setMainStore("toast", { severity: "error", life: 4000, summary: "", detail: "Пожалуйста, выберите метро" });
                                return true;
                            }
                        } else {
                            setErrorMetro(false);
                            return false;
                        }
                    }
                    break;

                case "filial":
                    if (require) {
                        if (offerItem?.addresses?.addresses.length === 0) {
                            setErrorFilial(false);
                            return false;
                        }
                        if (filialObj && filialObj.filial) {
                            setErrorFilial(false);
                            return false;
                        } else {
                            setErrorFilial(true);
                            mainStore.setMainStore("toast", { severity: "error", life: 4000, summary: "", detail: "Пожалуйста, выберите филиал" });
                            return true;
                        }
                    }

                    break;
                default:
                    break;
            }
        };

        const handleEmail = (e, key = false) => {
            const value = e.target.value.trim();

            if (value.length > 2) {
                setSuggestEmailValue(true);
                if (value.includes("@") && validateEmail(value)) {
                    setSuggestEmailValue(false);
                }
            } else {
                setSuggestEmailValue(false);
            }

            if (value.length > 100) {
                mainStore.setMainStore("toast", { severity: "error", life: 4000, summary: "", detail: "Email слишком длинный. Пожалуйста, сократите до 100 символов" });
            }

            setInputFieldsState((prev) => ({ ...prev, [key]: value }));
        };

        const handleName = (e, key) => {
            if (e.target.value.length > 100) {
                inputNameRef.current.closest(".right__input")?.classList.add("error");
                setErrorName(true);
                mainStore.setMainStore("toast", { severity: "error", life: 4000, summary: "", detail: "Имя слишком длинное. Пожалуйста, сократите до 100 символов" });
            }
            setInputFieldsState((prev) => ({ ...prev, [key]: e.target.value.trimLeft() }));
        };

        const handlePhone = (e) => {
            setInputFieldsState({ ...inputFieldsState, phone: e.target.value.replace(/\D/gim, "") });
        };

        const focusedInput = (ref) => {
            setErrorEmail(false);
            setErrorName(false);
            setErrorPhone(false);
            setLoaderBtn(false);
            if (ref.current.focus) {
                ref.current.focus();
            } else {
                ref.current.getInputDOMNode().focus();
            }
        };

        const handleClickSuggest = (sug) => {
            if (inputFieldsState["email"].includes("@")) {
                setInputFieldsState({ ...inputFieldsState, email: inputFieldsState["email"].split("@")[0] + sug });
                setSuggestEmailValue(false);
            } else {
                setInputFieldsState((prev) => ({
                    ...prev,
                    ["email"]: prev["email"] + sug,
                }));
                setSuggestEmailValue(false);
            }
        };

        const handleUpdateLocation = async (value) => {
            const regionId = value.regionId || value.parentId;
            const localeRisPromo = JSON.parse(localStorage.getItem("locale_ris_promo"));
            const selectRegion = mainStore.getMainStore("locationData")?.find((region) => region._id === regionId);

            if (!regionId || localeRisPromo?._id === regionId) return;

            const inData = {
                regionId,
                cityId: value._id || "",
            };

            if (selectRegion) {
                saveToLocalStorage("locale_ris_promo", selectRegion);
            }

            mainStore.setMainStore("userLocation", {
                ...userLocation,
                regionId,
            });

            await mainStore.getByUrl("/app_rispromo_user/update_location", inData, false, "", false);
        };

        const onSubmitGetPromo = async (obj, paramsKey8) => {
            setLoaderBtn(true);
            const cap_token = mainStore.getMainStore("capToken"); // забираем полученный токен при включении формы

            sendMetric(`click_offer_get`, {
                params1: [`${abTestMetika ? abTestMetika : "ris_promo"}`],
                params2: offerItem?._id,
                params3: getSqlServerGuidHash(offerItem.code, offerItem.vendor?._id),
                params4: offerItem?.code,
                params6: isAbTestMetrika ? `${isAbTestMetrika}` : null,
                params7: paramsKey8,
                params8: what_id,
            });

            if (window.risMetrika && typeof window.risMetrika.reachgoal_ch === "function") {
                window.risMetrika.reachgoal_ch({
                    event: "click_offer_get",
                    siteId: what_id, //'id витрины',
                    offerId: offerItem?._id, //'id оффера'
                    variantCode: offerItem?._ab_code, //'в оффере новый ключ _ab_code',
                    position: offerItem.positionIdx, //'Позиция оффера на витрине, не путать с сортировкой!!!' ,
                    sort: offerItem?.sortNum, //'Сортировка оффера на витрине!!!' ,
                    session_uuid: localStorage.getItem("_r_p_s"),
                    widget_code: wdCd ? wdCd : "",
                    ml_traffic_mode: wdm ? wdm : "",
                    ml_model_code: wd_mc ? wd_mc : "",
                });
            }

            if (!localStorage.getItem("first_click_offer_get")) {
                sendMetric(`first_click_offer_get`, {
                    params1: [`${abTestMetika ? abTestMetika : "ris_promo"}`],
                    params2: offerItem?._id,
                    params3: getSqlServerGuidHash(offerItem.code, offerItem.vendor?._id),
                    params4: offerItem?.code,
                    params6: isAbTestMetrika ? `${isAbTestMetrika}` : null,
                    params7: paramsKey8,
                    params8: what_id,
                });
                localStorage.setItem("first_click_offer_get", true);
            }
            const isInput = offerItem?.inputFields.map((field) => field.key) || [];

            const newObj = {
                email: isInput.includes("email") ? inputFieldsState.email : false,
                phone: isInput.includes("phone") ? inputFieldsState.phone : false,
                name: isInput.includes("name") ? inputFieldsState.name : false,
                offerId: offerItem._id,
                cap_token: cap_token ? cap_token : null,
                regionId: regionId,
                cityId: cityId,
                metroId: metroId,
                positionOffer: indexPositionMetrick,
                cityName: filialObj.city ? filialObj.city : null,
                filialName: filialObj.filial ? filialObj.filial : null,
                metroName: filialObj.metro ? filialObj.metro : null,
                questions: formQuestionsChain.map(({ question, answer }) => ({ question, answer })),
            };

            console.log("newObj", newObj);

            const resp = await mainStore.getByUrl("app_rispromo/get_promo", newObj, false, "", false, getPromoUrl ? { baseURL: `${getPromoUrl}services` } : false);

            if (resp?.success) {
                mainStore.setMainStore("formQuestionsChain", []);
                mainStore.setMainStore("promoIdCity", false);
                mainStore.setMainStore("promoIdRegion", false);
                mainStore.setMainStore("promoIdMetro", false);
                setLoaderBtn(false);

                if (resp.data && resp.data.isAlreadyReceivedVendor) {
                    if (isMobile) {
                        setSendPhone("received");
                    } else {
                        mainStore.setMainStore("modal", { type: "recommendation", offerItem });
                    }
                    return;
                }

                if (!localStorage.getItem("first_get_promo")) {
                    sendMetric(`first_get_promo`, {
                        params1: [`${abTestMetika ? abTestMetika : "ris_promo"}`],
                        params2: offerItem?._id,
                        params3: getSqlServerGuidHash(offerItem.code, offerItem.vendor?._id),
                        params4: offerItem?.code,
                        params6: isAbTestMetrika ? `${isAbTestMetrika}` : null,
                        params7: paramsKey8,
                        params8: what_id,
                    });
                    localStorage.setItem("first_get_promo", true);
                }

                sendMetric(`get_promo`, {
                    params1: [`${abTestMetika ? abTestMetika : "ris_promo"}`],
                    params2: offerItem?._id,
                    params3: getSqlServerGuidHash(offerItem.code, offerItem.vendor?._id),
                    params4: offerItem?.code,
                    params6: isAbTestMetrika ? `${isAbTestMetrika}` : null,
                    params7: paramsKey8,
                    params8: what_id,
                });

                if (window.risMetrika && typeof window.risMetrika.reachgoal_ch === "function") {
                    window.risMetrika.reachgoal_ch({
                        event: "get_promo",
                        siteId: what_id, //'id витрины',
                        offerId: offerItem?._id, //'id оффера'
                        variantCode: offerItem?._ab_code, //'в оффере новый ключ _ab_code',
                        position: offerItem?.positionIdx, //'Позиция оффера на витрине, не путать с сортировкой!!!' ,
                        sort: offerItem?.sortNum, //'Сортировка оффера на витрине!!!' ,
                        session_uuid: localStorage.getItem("_r_p_s"),
                        widget_code: wdCd ? wdCd : "",
                        ml_traffic_mode: wdm ? wdm : "",
                        ml_model_code: wd_mc ? wd_mc : "",
                    });
                }

                setSendPhone(false);

                const adapted = mainStore.addPromoToOffer(resp.data);

                if (adapted?.offers) {
                    let newObjOffer = adapted?.offers.find((it) => it._id === offerItem._id);
                    if (newObjOffer) {
                        setLoaderBtn(false);

                        if (isMobile) {
                            setIsAccordionOpen(newObjOffer);
                        } else {
                            if (newObjOffer.ghostOffer) {
                                mainStore.setMainStore("modal", { type: "ghost", offerItem: newObjOffer });
                            } else {
                                mainStore.setMainStore("modal", { type: "promo", offerItem: newObjOffer });
                            }
                        }
                        const isHref = offerItem.activationLink.includes("{{PROMOCODE}}");
                        navModalPromo(newObjOffer, isHref);
                    }
                }
            }
            mainStore.setMainStore("capToken", "qwerty");
        };

        const navModalPromo = (newObjOffer, isHref = false) => {
            if (newObjOffer && newObjOffer.offerOptions) {
                newObjOffer.offerOptions.map((item) => {
                    if (item === "redirect" && newObjOffer?.activationLink?.length > 0) {
                        sendMetric("autoredirect", {
                            params1: [`${abTestMetika ? abTestMetika : "ris_promo"}`],
                            params2: newObjOffer?._id,
                            params3: getSqlServerGuidHash(newObjOffer.code, newObjOffer.vendor?._id),
                            params4: newObjOffer?.code,
                            params6: isAbTestMetrika ? `${isAbTestMetrika}` : null,
                            params7: null,
                            params8: what_id,
                        });

                        const hrefOut = newObjOffer.activationLink;

                        if (offerItem?.offerType !== "partnerlink") {
                            if (isHref) {
                                if (isMobile) {
                                    setTimeout(() => {
                                        window.open(hrefOut, "_self");
                                    }, 200);
                                } else {
                                    window.open(hrefOut, "_blank");
                                }
                            } else {
                                setTimeout(() => {
                                    window.open(`${window.location.href}&noym=1`, "_blank");
                                    window.open(hrefOut, "_self");
                                }, 200);
                            }
                        } else {
                            if (newObjOffer.offerType !== "leads") {
                                isMobile ? window.open(hrefOut, "_self") : window.open(hrefOut, "_blank");
                            }
                        }
                    }
                });
            }
        };

        const handleClickPromoBtn = (e) => {
            e.preventDefault();
            setLoaderBtn(true);
            handleGetPromo();
        };

        const handleGetPromo = () => {
            const cap_token = mainStore.getMainStore("capToken"); // забираем полученный токен при включении формы
            const captcha = mainStore.getMainStore("captcha"); // забираем полученный токен при включении формы

            if (!isCaptchaEnabled || (cap_token && cap_token != "qwerty" && !captcha)) {
                setLoaderBtn(false);
                handleClick(); // идем на запрос промо с текущим токеном
            } else {
                mainStore.setMainStore("captcha", "captcha_modal-offer");
                mainStore.setMainStore("captchaRisMetrika", {
                    event: "captcha",
                    siteId: what_id, //'id витрины',
                    offerId: offerItem?._id, //'id оффера'
                    variantCode: offerItem?._ab_code, //'в оффере новый ключ _ab_code',
                    position: offerItem?.positionIdx, //'Позиция оффера на витрине, не путать с сортировкой!!!' ,
                    sort: offerItem?.sortNum, //'Сортировка оффера на витрине!!!' ,
                    session_uuid: localStorage.getItem("_r_p_s"),
                    widget_code: wdCd ? wdCd : "",
                    ml_traffic_mode: wdm ? wdm : "",
                    ml_model_code: wd_mc ? wd_mc : "",
                }); // включаем капчу в форме и получаем новый токен
            }
        };

        const handleHiddenCaptcha = () => {
            setLoaderBtn(false);
            mainStore.setMainStore("captcha", false);
        };

        const handleInstruction = () => {
            sendMetric("click_instruction_offer", {
                params1: [`${abTestMetika ? abTestMetika : "ris_promo"}`],
                params2: offerItem?._id,
                params3: getSqlServerGuidHash(offerItem.code, offerItem.vendor?._id),
                params4: offerItem?.code,
                params6: isAbTestMetrika ? `${isAbTestMetrika}` : null,
                params7: null,
                params8: what_id,
            });
        };

        const handleClickGhost = () => {
            mainStore.setMainStore("modal", false);

            if (isMobile) {
                setIsAccordionOpen(false);
            }
            clearParamWithoutRerender(["id", "code"]);

            sendMetric("click_offer_button_ghost_exit", {
                params1: [`${abTestMetika ? abTestMetika : "ris_promo"}`],
                params2: offerItem?._id,
                params3: getSqlServerGuidHash(offerItem.code, offerItem.vendor?._id),
                params4: offerItem?.code,
                params6: isAbTestMetrika ? `${isAbTestMetrika}` : null,
                params7: null,
                params8: what_id,
            });
        };

        const percentFilling = () => {
            let percent = percentNumber;

            if (offerItem?.inputFields?.length) {
                const filled = [];
                offerItem.inputFields.forEach((field) => {
                    let value = inputFieldsState[field.key];
                    if (value) {
                        percent += 10;
                        filled.push(field.key);
                    } else {
                        if (field.key === "city" && filialObj.city) {
                            percent += 10;
                            filled.push(field.key);
                        }

                        if (field.key === "filial" && filialObj.filial) {
                            percent += 10;
                            filled.push(field.key);
                        }
                    }
                });
                if (offerItem.inputFields.length === filled.length) {
                    percent = 80;
                }

                if (sendPhone) {
                    percent = 99;
                }
            } else {
                percent = 80;
            }

            return percent;
        };

        const { regionIds, cityIds, metroStationIds } = extractGeoArrays(offerItem?.geoObject);

        const arrFilterReg = regionIds.filter((f) => f === "664746e41feb2258b05f5e68" || f === "664746e41feb2258b05f5e69");

        const arrCityFilial = cityArr ? cityArr.filter((f) => cityIds.concat(arrFilterReg).find((find) => find === f._id) && f.cityReg !== "Москва" && f.cityReg !== "Санкт-Петербург") : [];
        const arrMetroFilial = metroArr
            ? arrCityFilial.length && offerItem?.inputFields?.some((i) => i.type === "city")
                ? metroArr.filter((f) => metroStationIds?.find((find) => find === f._id && cityIdFilter?.some((s) => s._id === f._id)))
                : metroArr.filter((f) => metroStationIds?.find((find) => find === f._id))
            : [];

        useEffect(() => {
            if (arrCityFilial.length === 1) {
                const nextFilialObj = { ...filialObj, city: arrCityFilial[0].city };
                delete nextFilialObj.metro;
                setFilialObj(nextFilialObj);
                setCityIdFilter(arrCityFilial[0].metro);

                handleUpdateLocation(arrCityFilial[0]);
            }
        }, [arrCityFilial.length]);

        return (
            <form className="ab-3274 form" ref={wrapperRef}>
                <Captcha onSuccess={handleGetPromo} onChallengeHidden={handleHiddenCaptcha} id="captcha_modal-offer" />

                {sendPhone === "received" ? (
                    <RecommendationModal offer={offerItem} setIsAccordionOpen={setIsAccordionOpen} />
                ) : offerItem.ghostOffer ? (
                    <div className="grost__form">
                        <div className="form__header">
                            <span className="title">{offerItem?.ghostOfferConfig && offerItem?.ghostOfferConfig.textTitle ? offerItem.ghostOfferConfig.textTitle : "Ой, это предложение больше не доступно"}</span>
                            <span className="desc">{offerItem?.ghostOfferConfig && offerItem?.ghostOfferConfig.textDesc ? offerItem.ghostOfferConfig.textDesc : "Мы пришлем вам письмо, когда предложение снова появятся"}</span>
                        </div>
                        {offerItem.ghostOfferConfig?.typeOffer ? (
                            <InputTextUi
                                value={inputFieldsState["email"] || ""}
                                onChange={(e) => handleEmail(e, "email")}
                                placeholder={"Ваша почта"}
                                ref={inputEmailRef}
                                className="input_email"
                                onClick={() => focusedInput(inputEmailRef)}
                                handleClickSuggest={handleClickSuggest}
                                suggestEmailValue={suggestEmailValue}
                                error={errorEmail}
                                autoComplete="email"
                            />
                        ) : null}
                        <div className="button__group">
                            {offerItem.ghostOfferConfig?.typeOffer ? (
                                <ButtonUi label={offerItem?.ghostOfferConfig && offerItem?.ghostOfferConfig.textButton ? offerItem.ghostOfferConfig.textButton : "Уведомить меня"} onClick={handleClickPromoBtn} loaderBtn={loaderBtn} id="button_send" />
                            ) : null}
                            <ButtonUi label={"Выбрать другое предложение"} onClick={handleClickGhost} className="button__close" />
                        </div>
                    </div>
                ) : offerItem.offerDetail.showInputsInModal ? null : (
                    <>
                        {offerItem?.inputFields?.length
                            ? [...offerItem.inputFields]
                                  .sort((a, b) => a.sort - b.sort)
                                  .map((it, index) => {
                                      switch (it.key) {
                                          case "city":
                                              return sendPhone ? null : offerItem.addresses && offerItem.addresses.addresses.length ? (
                                                  <div key={index}>
                                                      <FilialBlock
                                                          errorCity={errorCity}
                                                          errorFilial={errorFilial}
                                                          setErrorFilial={setErrorFilial}
                                                          setErrorCity={setErrorCity}
                                                          data={offerItem.addresses}
                                                          setFilialObj={setFilialObj}
                                                          filialObj={filialObj}
                                                          handleUpdateLocation={handleUpdateLocation}
                                                          cityArr={cityArr}
                                                      />
                                                  </div>
                                              ) : (
                                                  <div style={{ marginBottom: "10px" }}>
                                                      <SelectFilialUI
                                                          error={errorCity}
                                                          data={arrCityFilial}
                                                          disable={arrCityFilial.length === 1}
                                                          onChange={(el, id) => {
                                                              const nextFilialObj = { ...filialObj, city: el.city };
                                                              delete nextFilialObj.metro;
                                                              setFilialObj(nextFilialObj);
                                                              setCityIdFilter(el.metro);
                                                              handleUpdateLocation(el);
                                                          }}
                                                          title={filialObj.city ? filialObj.city : "Выберите город"}
                                                      />
                                                  </div>
                                              );

                                          case "metro":
                                              return sendPhone ? null : arrMetroFilial.length ? (
                                                  <div key={index} style={{ marginBottom: "10px" }}>
                                                      <SelectFilialUI
                                                          error={errorMetro}
                                                          data={arrMetroFilial}
                                                          onChange={(el, id) => {
                                                              setFilialObj({ ...filialObj, metro: el.name });

                                                              if (el.parentType === "region") {
                                                                  handleUpdateLocation({ ...el, _id: null });
                                                                  return;
                                                              }

                                                              if (el.parentType === "city") {
                                                                  const parentCity = cityArr?.find((city) => city._id === el.parentId);

                                                                  if (!parentCity) return;

                                                                  handleUpdateLocation(parentCity);
                                                              }
                                                          }}
                                                          title={filialObj.metro ? filialObj.metro : "Выберите метро"}
                                                          disable={offerItem.inputFields.some((i) => i.type === "city") ? !filialObj.city : false}
                                                      />
                                                  </div>
                                              ) : null;
                                          case "email":
                                              return sendPhone ? null : (
                                                  <InputTextUi
                                                      key={index}
                                                      value={inputFieldsState[it.key] || ""}
                                                      onChange={(e) => handleEmail(e, "email")}
                                                      placeholder={it.placeholder}
                                                      ref={inputEmailRef}
                                                      className="input_email"
                                                      onClick={() => focusedInput(inputEmailRef)}
                                                      handleClickSuggest={handleClickSuggest}
                                                      suggestEmailValue={suggestEmailValue}
                                                      error={errorEmail}
                                                      autoComplete="email"
                                                      autoFocus={index === 0}
                                                  />
                                              );
                                          case "name":
                                              return sendPhone ? null : (
                                                  <InputTextUi
                                                      key={index}
                                                      value={inputFieldsState[it.key] || ""}
                                                      onChange={(e) => handleName(e, "name")}
                                                      placeholder={it.placeholder}
                                                      ref={inputNameRef}
                                                      className="input_name"
                                                      onClick={() => focusedInput(inputNameRef)}
                                                      error={errorName}
                                                      autoComplete="name"
                                                      autoFocus={index === 0}
                                                  />
                                              );
                                          case "phone":
                                              if (it.isVerified) {
                                                  return (
                                                      <VerificationPhone
                                                          key={index}
                                                          inputPhoneRef={inputPhoneRef}
                                                          handlePhone={handlePhone}
                                                          maskType={maskType}
                                                          placeholder={it.placeholder}
                                                          setCodeValue={setCodeValue}
                                                          codeValue={codeValue}
                                                          sendPhone={sendPhone}
                                                          setSendPhone={setSendPhone}
                                                          inputFieldsState={inputFieldsState}
                                                          error={errorPhone}
                                                          errorCode={error}
                                                          setErrorCode={setError}
                                                          handleClick={handleClick}
                                                          loaderBtn={loaderBtn}
                                                          offerItem={offerItem}
                                                          smsProviderType={smsType}
                                                          setSmsType={setSmsType}
                                                          shouldStopRef={shouldStopRef}
                                                          setLoaderBtn={setLoaderBtn}
                                                          autoFocus={index === 0}
                                                      />
                                                  );
                                              } else {
                                                  return (
                                                      <div className={`phone-input ${errorPhone ? "phone-input_error" : ""} ${inputFieldsState.phone.length > 10 ? "phone-input_filled" : ""} `} key={index}>
                                                          <InputMask
                                                              autocomplete="new-password"
                                                              ref={inputPhoneRef}
                                                              onChange={handlePhone}
                                                              mask={maskType}
                                                              showMask={focusMask}
                                                              replacement={{ _: /\d/ }}
                                                              className={`phone-input__field ${inputFieldsState.phone?.length > 1 ? "" : "phone-input__field_empty"} ${focusMask || inputFieldsState.phone.length ? "phone-input__field_focus" : ""}`}
                                                              id="phones"
                                                              onFocus={() => {
                                                                  const stateDigits = inputFieldsState.phone && inputFieldsState.phone !== false ? String(inputFieldsState.phone).replace(/\D/g, "") : "";
                                                                  const inputDigits = inputPhoneRef.current?.value?.replace(/\D/g, "") ?? "";

                                                                  if (stateDigits.length > 1 && inputDigits !== stateDigits) {
                                                                      inputPhoneRef.current.value = formatPhoneNumber(inputFieldsState.phone);
                                                                  }

                                                                  if (inputDigits.length > 1 || stateDigits.length > 1) {
                                                                      setFocusMask(true);
                                                                      return;
                                                                  }

                                                                  if (inputPhoneRef.current) {
                                                                      inputPhoneRef.current.value = "+7 (___) ___-__-__";
                                                                  }
                                                                  setFocusMask(true);
                                                              }}
                                                              onBlur={() => {
                                                                  setFocusMask(false);
                                                                  if (!inputFieldsState.phone.length) {
                                                                      inputPhoneRef.current.value = "";
                                                                  }
                                                              }}
                                                          />
                                                          <label className="phone-input__label">Ваш номер телефона</label>
                                                      </div>
                                                  );
                                              }
                                      }
                                  })
                            : null}
                    </>
                )}
                {sendPhone === "received" ? null : (
                    <>
                        {!offerItem.ghostOffer ? (
                            <div className="form__captcha">
                                <div className="form__button">
                                    <ButtonUi label={offerButtonLabel} onClick={handleClickPromoBtn} loaderBtn={loaderBtn} id="button_send" className="form__button_get-offer" />
                                    {/* {isMobile ? <Share mobile={true} offer={offerItem} /> : null} */}
                                </div>
                            </div>
                        ) : null}

                        {!offerItem.ghostOffer && showLegalInfo ? (
                            <div className="form__desc">
                                Нажимая кнопку «{offerButtonLabel}», я соглашаюсь с{" "}
                                <a href="https://ris.promo/pdf/privacy.pdf" target="_blank" rel="noreferrer">
                                    политикой конфиденциальности
                                </a>
                                {offerItem?.inputFields?.length ? (
                                    <>
                                        , а также даю согласие{" "}
                                        <a href="https://ris.promo/pdf/consent_to_advertising.pdf" target="_blank" rel="noreferrer">
                                            ООО «РИС»
                                        </a>{" "}
                                        и{" "}
                                        <a
                                            // костыль, задача DEV-2701
                                            href={vendorId === "668e4671a0021c8424c389ff" ? "https://storage.yandexcloud.net/rp-dev-assets/ris_promo_pdf/ris_promo/t-bank.docx" : `/documents/personal-data/${vendorId}`}
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            {vendorName}
                                        </a>{" "}
                                        на направление мне рекламных сообщений и на{" "}
                                        <a href={`/documents/ad-agreement/${vendorId}`} target="_blank" rel="noreferrer">
                                            обработку персональных данных
                                        </a>
                                    </>
                                ) : null}
                                .
                            </div>
                        ) : null}

                        {!offerItem.ghostOffer && showLegalInfo ? <div className="form__ord">{ord}</div> : null}

                        {!offerItem.ghostOffer && offerItem?.offerDetail?.miniDisc ? <div className="form__instructions" onClick={handleInstruction} dangerouslySetInnerHTML={{ __html: offerItem?.offerDetail.miniDisc }} /> : null}
                    </>
                )}
            </form>
        );
    }),
);

const areEqual = (prevProps, nextProps) => {
    const prev = prevProps.offerItem;
    const next = nextProps.offerItem;

    return prev !== next;
};

function extractGeoArrays(geoObject = {}) {
    const regionIds = [];
    const cityIds = [];
    const metroStationIds = [];

    for (const regionId in geoObject) {
        if (!Object.hasOwn(geoObject, regionId)) continue;
        regionIds.push(regionId);

        const regionContent = geoObject[regionId];

        // Обработка городов
        if (regionContent.cities && typeof regionContent.cities === "object") {
            for (const cityId in regionContent.cities) {
                if (Object.hasOwn(regionContent.cities, cityId)) {
                    cityIds.push(cityId);
                }

                const cityContent = regionContent.cities[cityId];

                if (cityContent?.metroStations && typeof cityContent?.metroStations === "object") {
                    for (const metroId in cityContent.metroStations) {
                        if (Object.hasOwn(cityContent.metroStations, metroId)) {
                            metroStationIds.push(metroId);
                        }
                    }
                }
            }
        }

        // Обработка станций метро
        if (regionContent.metroStations && typeof regionContent.metroStations === "object") {
            for (const metroId in regionContent.metroStations) {
                if (Object.hasOwn(regionContent.metroStations, metroId)) {
                    metroStationIds.push(metroId);
                }
            }
        }
    }

    return { regionIds, cityIds, metroStationIds };
}

export default React.memo(AB_3274, areEqual);
